import { IFieldElem } from '@models/IFormData';
import { UseFormReturn } from 'react-hook-form';
import { FormulaManager } from '@utils/managers/FormulaManager';
import { substituteFormulaData } from './formulaStringLiteral';

export class SetConditionManager {
    private _setValue: any;
    private _fieldsData: Record<string, IFieldElem>;
    private _methods: UseFormReturn<any>;
    private _isNew: boolean;
    private _isEdit: boolean;

    constructor(
        setValue: any,
        fieldsData: Record<string, IFieldElem>,
        methods: UseFormReturn<any>,
        isNew: boolean,
        isEdit: boolean,
    ) {
        this._setValue = setValue;
        this._fieldsData = fieldsData;
        this._methods = methods;
        this._isNew = isNew;
        this._isEdit = isEdit;
    }

    public async checkConditionAsync(condition: string) {
        if (!condition) return true;

        const setValue: unknown = this._setValue;
        // Строка — всегда строковый литерал (как прежнее '…'), но экранированный: кавычка или
        // код в значении не становятся частью условия; в '{value}' подставляется содержимое.
        // Число/boolean/null — как раньше, скаляром; дата — timestamp, как в checkCondition;
        // прочий объект (json) — строкой, не кодом.
        const formula = substituteFormulaData(condition, /\{value\}/, () => {
            if (setValue instanceof Date) return { value: setValue.getTime() };
            return typeof setValue === 'string' || (typeof setValue === 'object' && setValue !== null)
                ? { text: String(setValue) }
                : { value: setValue };
        });

        const formulaMgr = new FormulaManager(formula);
        formulaMgr.Init(this._fieldsData, this._methods);
        return (await formulaMgr.EvalFormulaValues(this._isEdit, this._isNew)) as boolean;
    }
}
